import Swiper from "swiper";

export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

  const swiperDropNewModels = new Swiper ('.swiper-drop-new-models', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.drop-next-models',
      prevEl: '.swiper-button-prev.drop-prev-models',
    },
    pagination: {
      el: '.swiper-pagination.drop-new-models',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const swiperDropNewModelsTabs = new Swiper ('.swiper-drop-new-models-tabs', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.drop-next-models-tabs',
      prevEl: '.swiper-button-prev.drop-prev-models-tabs',
    },
    pagination: {
      el: '.swiper-pagination.drop-new-models-tabs',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const swiperNewModels = new Swiper ('.swiper-new-model', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.new-model',
      prevEl: '.swiper-button-prev.new-model',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1600: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperNewModelVersion = new Swiper ('.swiper-new-model-version', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.version',
      prevEl: '.swiper-button-prev.version',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });

  const swiperLocations = new Swiper('.swiper-locations', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.locations',
      prevEl: '.swiper-button-prev.locations',
    },
    pagination: {
      el: '.swiper-pagination.locations',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperPromotion = new Swiper ('.swiper-promotion', {
    slidesPerView: 1,
    watchOverflow: true,
    observer: true,
    navigation: {
      nextEl: '.swiper-button-next.promotion',
      prevEl: '.swiper-button-prev.promotion',
    },
    pagination: {
      el: '.swiper-pagination.promotion',
      clickable: true,
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
      },

      1366: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  const blogInternalRelatedSwiper = new Swiper('.blog-internal-related-slider', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 1,
    watchOverflow: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.blog-internal',
      prevEl: '.swiper-button-prev.blog-internal',
    },
    pagination: {
      el: '.swiper-pagination.blog-internal',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    }
  });

  const swiperVideos = new Swiper ('.swiper-videos', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.videos',
      prevEl: '.swiper-button-prev.videos',
    },
    pagination: {
      el: '.swiper-pagination.videos',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      }
    }
  });


  
  const swiperUsedModelInternalStamp = new Swiper('.used-model-internal-stamps-slider', {
    clickable: true,
    slidesPerView: 3,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });

  const swiperUsedModelInternalThumbs = new Swiper('.used-model-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.used-thumbs',
      prevEl: '.swiper-button-prev.used-thumbs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const usedModelInternalSwiper = new Swiper('.used-model-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    clickable: true,
    thumbs: {
      swiper: swiperUsedModelInternalThumbs,
    },
  });

  const swiperNewModelInternalThumbs = new Swiper('.new-model-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.new-thumbs',
      prevEl: '.swiper-button-prev.new-thumbs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const newModelInternalSwiper = new Swiper('.new-model-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.new',
      prevEl: '.swiper-button-prev.new',
    },
    clickable: true,
    thumbs: {
      swiper: swiperNewModelInternalThumbs,
    },
  });


  const newModelsSpecBanners = new Swiper('.new-models-specs-banner', {
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next.specs-banner',
      prevEl: '.swiper-button-prev.specs-banner',
    }
  });

  const swiperUsedModelInternalRelated = new Swiper('.used-model-internal-related-slider', {
    clickable: true,
    slidesPerView: 1,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    pagination: {
      el: '.swiper-pagination.related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.related',
      prevEl: '.swiper-button-prev.related',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  });


  const swiperHighlights = new Swiper('.swiper-highlights', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.highlights',
      prevEl: '.swiper-button-prev.highlights',
    },
    pagination: {
      el: '.swiper-pagination.highlights',
      clickable: true,
    },
    pagination: {
      el: '.swiper-pagination.highlights',
      clickable: true
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });


  const usedModel = new Swiper('.swiper-used-models', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.new-models-specs-banner-models',
      prevEl: '.swiper-button-prev.used-models',
    },
    pagination: {
      el: '.swiper-pagination.used-models',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

}



